import React from 'react';

const BankTransferDetails = () => {
  return (
    <div className='bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden'>
      <div className='p-6'>
        <h3 className='text-lg font-semibold text-slate-900 mb-4'>Realiza tu pago por transferencia</h3>
        <dl className='divide-y divide-slate-100'>
          <div className='py-3 flex items-start justify-between'>
            <dt className='text-slate-600'>Beneficiario</dt>
            <dd className='text-slate-900 font-medium ml-4 text-right'>Claim Up</dd>
          </div>
          <div className='py-3 flex items-start justify-between'>
            <dt className='text-slate-600'>Entidad</dt>
            <dd className='text-slate-900 font-medium ml-4 text-right'>BBVA</dd>
          </div>
          <div className='py-3 flex items-start justify-between'>
            <dt className='text-slate-600'>IBAN</dt>
            <dd className='text-slate-900 font-semibold ml-4 text-right font-mono tracking-wide'>
              ES18 0182 8510 9702 0000 7593
            </dd>
          </div>
          <div className='py-3 flex items-start justify-between'>
            <dt className='text-slate-600'>Concepto</dt>
            <dd className='text-slate-900 ml-4 text-right'>Nombre titular de la deuda</dd>
          </div>
        </dl>

        <p className='mt-4 text-sm text-slate-600'>
          Importante: Indica el <span className='font-medium'>concepto</span> tal como aparece para agilizar la
          identificación de tu pago.
        </p>
      </div>
    </div>
  );
};

export default BankTransferDetails;
